if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.viewer) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

        if (!this.elements.thumbnails) return;

        // Delegated click: keeps working after thumbnails are re-rendered
        this.elements.thumbnails.addEventListener('click', (event) => {
          const button = event.target.closest('[data-target] button');
          if (!button) return;
          this.setActiveMedia(button.closest('[data-target]').dataset.target, false);
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;
        const mediaId = event.detail?.currentElement?.dataset?.mediaId;
        if (!mediaId) return;
        this.setActiveThumbnail(this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`));
      }

      setActiveMedia(mediaId, prepend) {
        const viewer = this.elements.viewer;
        if (!viewer) return;

        const activeMedia = viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        viewer.querySelectorAll('[data-media-id]').forEach((element) => element.classList.remove('is-active'));
        activeMedia.classList.add('is-active');

        const thumbnails = this.elements.thumbnails;
        const activeThumbnail = thumbnails?.querySelector(`[data-target="${mediaId}"]`) || null;

        if (prepend) {
          const mediaList = activeMedia.parentElement;
          if (mediaList.firstElementChild !== activeMedia) mediaList.prepend(activeMedia);

          if (activeThumbnail) {
            const thumbList = activeThumbnail.parentElement;
            if (thumbList.firstElementChild !== activeThumbnail) thumbList.prepend(activeThumbnail);
          }

          if (viewer.slider && typeof viewer.resetPages === 'function') viewer.resetPages();
          if (thumbnails?.slider && typeof thumbnails.resetPages === 'function') thumbnails.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          window.scrollTo({ top: activeMediaRect.top + window.scrollY, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!activeThumbnail) return;
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        const thumbnails = this.elements.thumbnails;
        if (!thumbnails || !thumbnail) return;

        thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);

        if (typeof thumbnails.isSlideVisible === 'function' && thumbnails.isSlideVisible(thumbnail, 10)) return;
        thumbnails.slider?.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        const liveRegion = this.elements.liveRegion;
        if (!image || !liveRegion || !window.accessibilityStrings?.imageAvailable) return;

        image.onload = () => {
          liveRegion.setAttribute('aria-hidden', false);
          liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => liveRegion.setAttribute('aria-hidden', true), 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}